import type { Board } from '../engine/board';
import { DELTA, opens, type Tile } from '../engine/level';

export class Renderer {
  readonly ctx: CanvasRenderingContext2D;
  dpr = 1; w = 0; h = 0; ox = 0; oy = 0; cw = 0;
  constructor(readonly canvas: HTMLCanvasElement) { this.ctx = canvas.getContext('2d')!; }
  resize(w: number, h: number, dpr: number, rows: number, cols: number) {
    this.dpr = Math.min(dpr, 2); this.w = w; this.h = h;
    this.canvas.width = Math.round(w * this.dpr); this.canvas.height = Math.round(h * this.dpr);
    this.canvas.style.width = `${w}px`; this.canvas.style.height = `${h}px`;
    this.cw = Math.floor(Math.min((w * 0.94) / cols, (h * 0.94) / rows));
    this.ox = (w - this.cw * cols) / 2; this.oy = (h - this.cw * rows) / 2;
  }
  cellAt(x: number, y: number, rows: number, cols: number): [number, number] | null {
    const c = Math.floor((x - this.ox) / this.cw), r = Math.floor((y - this.oy) / this.cw);
    return r < 0 || c < 0 || r >= rows || c >= cols ? null : [r, c];
  }
  center(r: number, c: number): [number, number] { return [this.ox + (c + 0.5) * this.cw, this.oy + (r + 0.5) * this.cw]; }

  /** anim: 이동 중 타일 {r,c,dr,dc,t∈[0,1]}, ball: 굴러가는 공 위치(칸 좌표 실수) */
  draw(b: Board, anim: { r: number; c: number; dr: number; dc: number; t: number } | null, ball: [number, number] | null) {
    const { ctx, cw } = this;
    ctx.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);
    ctx.fillStyle = '#101010'; ctx.fillRect(0, 0, this.w, this.h);
    ctx.fillStyle = '#1a1a1a'; ctx.fillRect(this.ox, this.oy, cw * b.cols, cw * b.rows);
    for (let r = 0; r < b.rows; r++) for (let c = 0; c < b.cols; c++) {
      const t = b.tiles[r]![c]!;
      if (t.kind === 'empty') continue;
      let x = this.ox + c * cw, y = this.oy + r * cw;
      if (anim && anim.r === r && anim.c === c) { x += anim.dc * cw * anim.t; y += anim.dr * cw * anim.t; }
      this.tile(t, x, y, ball !== null);
    }
    if (ball) {
      const [x, y] = this.center(ball[0], ball[1]);
      ctx.fillStyle = '#e8e8e8'; ctx.beginPath(); ctx.arc(x, y, cw * 0.17, 0, Math.PI * 2); ctx.fill();
    }
  }
  private tile(t: Tile, x: number, y: number, rolling: boolean) {
    const { ctx, cw } = this;
    const pad = cw * 0.03;
    ctx.fillStyle = t.fixed ? '#6f6f6f' : '#b98553';
    ctx.strokeStyle = t.fixed ? '#4d4d4d' : '#8a5f38'; ctx.lineWidth = 2;
    ctx.beginPath(); ctx.roundRect(x + pad, y + pad, cw - pad * 2, cw - pad * 2, cw * 0.12); ctx.fill(); ctx.stroke();
    if (t.fixed) {
      ctx.fillStyle = '#3a3a3a';
      for (const [px, py] of [[0.14, 0.14], [0.86, 0.14], [0.14, 0.86], [0.86, 0.86]] as [number, number][]) { ctx.beginPath(); ctx.arc(x + px * cw, y + py * cw, cw * 0.035, 0, Math.PI * 2); ctx.fill(); }
    }
    if (t.kind === 'goal') { ctx.strokeStyle = '#d9433b'; ctx.lineWidth = 3; ctx.strokeRect(x + pad + 3, y + pad + 3, cw - pad * 2 - 6, cw - pad * 2 - 6); }
    // 홈
    const cx = x + cw / 2, cy = y + cw / 2;
    ctx.strokeStyle = '#2b1d12'; ctx.lineWidth = cw * 0.28; ctx.lineCap = 'butt';
    for (const d of opens(t)) {
      ctx.beginPath(); ctx.moveTo(cx, cy); ctx.lineTo(cx + DELTA[d][1] * cw * 0.5, cy + DELTA[d][0] * cw * 0.5); ctx.stroke();
    }
    if (opens(t).length) { ctx.fillStyle = '#2b1d12'; ctx.beginPath(); ctx.arc(cx, cy, cw * 0.14, 0, Math.PI * 2); ctx.fill(); }
    if (t.kind === 'goal') { ctx.fillStyle = '#d9433b'; ctx.beginPath(); ctx.arc(cx, cy, cw * 0.16, 0, Math.PI * 2); ctx.fill(); }
    if (t.kind === 'start' && !rolling) { ctx.fillStyle = '#e8e8e8'; ctx.beginPath(); ctx.arc(cx, cy, cw * 0.17, 0, Math.PI * 2); ctx.fill(); }
  }
}
